import { Device, WorkOrderDetailsDeviceData } from '@order-management/types';

export function getDeviceName(device: Device | WorkOrderDetailsDeviceData) {
  return device.name || device.serialNumber?.number || device.defaultName;
}
